import { Injectable } from "@angular/core";
import { Subscription } from "rxjs";
import { ApiService } from "../api.service";
import { PutUserSalesManagerParam } from "./model/PutUserSalesManagerParam";
import { SalesManager } from "./model/SalesManager";

@Injectable()
export class SalesManagerService {
    constructor(private apiService: ApiService) { }

    public getSalesManagers(callback: (value: SalesManager[]) => void): Subscription {
        return this.apiService.getInnerTargetApi('user/sales/manager', null, callback);
    }

    
    public putSalesManagers(body: PutUserSalesManagerParam, error?: (error: any) => void, complete?: () => void): Subscription {
        return this.apiService.putInnerTargetApi('user/sales/manager', body, null, error, complete);
    }

}


// WEBPACK FOOTER //
// ./src/app/services/sales/sales-manager.service.ts